import { render } from "./SearchFilter.vue?vue&type=template&id=5b8e8a54&scoped=true"
import script from "./SearchFilter.vue?vue&type=script&lang=js"
export * from "./SearchFilter.vue?vue&type=script&lang=js"

import "./SearchFilter.vue?vue&type=style&index=0&id=5b8e8a54&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b8e8a54"]])

export default __exports__